const PRIVILEGE_CONSTANTS = {
  "@ADMIN": "@admin",
};

export default PRIVILEGE_CONSTANTS;
